export default __webpack_public_path__ + "static/media/pdf.75f17552.png";